module.exports = __webpack_public_path__ + "img/hero.cf17e5bf.png";